<template>
  <label class="text-input" :class="{ 'text-input--focus': inFocus }">
    <input
      v-bind="$attrs"
      class="text-input__input"
      type="text"
      @change="handleInput"
      @focus="handleFocus"
      @blur="handleBlur"
    />
    <div v-if="$slots.append" class="text-input__append">
      <slot name="append" />
    </div>
  </label>
</template>

<script>
export default {
  inheritAttrs: false,
  modelValue: {
    type: String,
    required: false,
    default: ''
  },
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      inFocus: false
    };
  },
  methods: {
    handleInput(event) {
      const value = event.target.value;
      this.$emit('update:modelValue', value);
    },
    handleFocus() {
      this.inFocus = true;
    },
    handleBlur() {
      this.inFocus = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.text-input {
  background-color: color('white');
  border: 1px solid shade('white', 7%);
  display: flex;
  height: 3rem;
  transition: border-color 0.2s;
  width: 100%;

  &--focus {
    border-color: color('primary');
  }

  &__input {
    @include font('open-sans', 'normal');
    @include font-size('paragraph', 'md');
    appearance: none;
    background-color: transparent;
    background-image: none;
    border: 0;
    box-shadow: none;
    color: color('black');
    flex-grow: 1;
    outline: 0;
    padding: spacing('md');
    text-align: left;

    &::placeholder {
      color: color('gray');
    }
  }

  &__append {
    align-items: center;
    color: color('primary');
    cursor: auto;
    display: flex;
    flex-grow: 0;
    justify-content: center;
    padding-right: spacing('md');

    :deep(svg) {
      display: block;
    }
  }
}
</style>
